export const FETCH_METERS_REQUEST = '[Meters] FETCH_METERS_REQUEST';
export const FETCH_METERS_SUCCESS = '[Meters] FETCH_METERS_SUCCESS';
export const FETCH_METERS_FAILURE = '[Meters] FETCH_METERS_FAILURE';
